export const projectData = [
    {
        title: "Cul-de-sac",
        img:require("../assets/img/img1.png"),
        links:[
             {
                video:"https://www.youtube.com/embed/CtupWAHhh8c?si=RDBNjSqv4OPFwkqz"
            },
            {
                readme:"https://github.com/1stofhername/Phase1-Project/blob/main/README.md"
            },
        ],
        tools:["Vanilla Javascript", "OOP", "JSON", "CSS3"],
    },
    {
        title: "Idealist",
        img:require("../assets/img/img2.png"),
        links:[
            // {
            //     demo:"https://idealist-app.netlify.app/"
            // },
            {
                code:"https://github.com/1stofhername/deployed-idea-list/tree/main"
            },
            {
                readme:"https://github.com/1stofhername/deployed-idea-list/blob/main/README.md"
            }
        ],
        tools:["Javascript", "React.js", "JSX", "React Router", "CSS3", "Netlify"]

    },

    {
        title: "Portfolio",
        img:require("../assets/img/img3.png"),
        links:[
            {
                code:"https://github.com/1stofhername/portfolio-webstie"
            },
            {
                readme:"https://github.com/1stofhername/portfolio-webstie/blob/main/README.md"
            }
        ],
        tools:["Javascript", "React.js", "JSX", "React Router", "CSS3", "Framer motion", "NoSQL"]

    },
      {
        title: "Lawtiwa Website",
        img:require("../assets/img/img4.png"),
        links: [
            {
                live:"https://lawtiwabarbersalon.com"
            }
        ],
        tools:["Javascript", "React.js", "JSX", "CSS"]
    },
     {
        title: "Bus Life PNW",
        img:require("../assets/img/img5.png"),
        links: [
            {
                live:"https://buslifepnw.com"
            }
        ],
        tools:["Javascript", "React.js", "JSX", "CSS"]
    }
]

